import React, { useCallback } from 'react';
import { CalendarAction, ClearAction, Container, Wrapper } from './styled';
import { useDateTimeInput } from '../..';

export const DateTimeTextInputControls: React.FC = () => {
  const { value, disabled, setIsActive, setInput, setInputDate, onChange } =
    useDateTimeInput();

  const clear = useCallback(() => {
    setInputDate(undefined);
    setInput(undefined);
    onChange(undefined);
  }, [setInput, setInputDate, onChange]);

  return (
    <Container>
      {value && !disabled && (
        <Wrapper onClick={clear}>
          <ClearAction />
        </Wrapper>
      )}
      {!disabled && (
        <Wrapper onClick={() => setIsActive(true)}>
          <CalendarAction />
        </Wrapper>
      )}
    </Container>
  );
};
